const _env = (typeof window !== 'undefined' && window._env_) || {};
const API_URL = _env.REACT_APP_API_URL || process.env.REACT_APP_API_URL || 'http://localhost:4000';
const API_KEY = _env.REACT_APP_API_KEY || process.env.REACT_APP_API_KEY || '';

/**
 * Get common headers for API requests
 * @param {string|null} clientIP - The client's IP address
 * @returns {Object} Headers object
 */
const getHeaders = (clientIP = null) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  
  if (API_KEY) {
    headers['x-api-key'] = API_KEY;
  }
  
  if (clientIP) {
    headers['x-client-ip'] = clientIP;
  }
  
  return headers;
};

/**
 * Get the client's public IP address
 * @returns {Promise<string|null>}
 */
const getClientIP = async () => {
  try {
    const response = await fetch('https://api.ipify.org?format=json');
    if (response.ok) {
      const data = await response.json();
      return data.ip;
    }
    return null;
  } catch (error) {
    console.error('Error fetching client IP:', error);
    return null;
  }
};

/**
 * Track a visit to the application
 * @returns {Promise<{count: number}>}
 */
export const trackVisit = async () => {
  try {
    // Get client IP address
    const clientIP = await getClientIP();
    
    const response = await fetch(`${API_URL}/api/visits`, {
      method: 'POST',
      headers: getHeaders(clientIP),
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error('Error tracking visit:', error);
    return { count: 0 };
  }
};

/**
 * Get the current visit count
 * @returns {Promise<{count: number}>}
 */
export const getVisitCount = async () => {
  try {
    const response = await fetch(`${API_URL}/api/visits`, {
      headers: getHeaders(),
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error('Error fetching visit count:', error);
    return { count: 0 };
  }
};

const api = {
  trackVisit,
  getVisitCount,
};

export default api;
